import { useState } from 'react';

import StructuredFilter from '@/features/StructuredFilter/StructuredFilter';
import structuredFilterUtils from '@/features/StructuredFilter/utils/structuredFilter.utils';
import useStructuredFilter from '@/hooks/domain/App/useStructuredFilter';
import type { FullColumnKey } from '@/types/filterKeyConst';

import { useFieldContext } from './form';

interface FormStructuredFilterProps {
  disAllowFilter?: FullColumnKey[];
}

export function FormStructuredFilter({
  disAllowFilter,
}: FormStructuredFilterProps) {
  const field = useFieldContext<StructuredFilter | undefined>();
  const { parseStructuredFilter } = useStructuredFilter();

  // Form 값을 UI 포맷으로 변환하여 내부 상태로 관리
  const [filterFormats, setFilterFormats] = useState<
    StructuredFilterQueryFormatT[]
  >(() => {
    const value = field.state.value;
    if (value && Object.keys(value).length > 0) {
      return parseStructuredFilter(value);
    }
    return [];
  });

  // UI 변경 시 form state 업데이트
  const handleChange = (values: StructuredFilterQueryFormatT[]) => {
    setFilterFormats(values);
    const filter = structuredFilterUtils.buildStructuredFilter(values);
    field.handleChange(filter);
  };

  // 필터 초기화
  const handleClear = () => {
    setFilterFormats([]);
    field.handleChange(undefined);
  };

  return (
    <StructuredFilter
      values={filterFormats}
      onChange={handleChange}
      clearFilter={handleClear}
      disAllowFilter={disAllowFilter}
    />
  );
}
